import { Component, OnInit } from '@angular/core';
import { Group } from '@core/objects/group';

import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

@Component({
    selector: 'settings-groups-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class SettingsGroupsMainComponent implements OnInit{
    private readonly ACCESS = 'access_setting_groups_access';

    public showForm: boolean = false;
	public access:boolean = true;

    public selectedGroup: Group = null;
    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        }
    ];

    public menu: Array<ThreeDotsMenuItem> = [{
        title: "Create a new user group",
        key: "add-group",
        icon: "add",
        order: 1
    }];

	constructor(public app: AppService, private title: TitleService){}

	ngOnInit(){
        this.title.set("User groups - System settings");

        this.app.getSession().subscribe( (session: any) => {
            // this.session = session;
            this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
            // this.licensed = this.session.options.license !== null;
            // this.loaded = true;
        });
	}

    onMenuClick(key: string) {
        switch(key) {
            case "add-group":
                this.showForm = !this.showForm;
                break;
        }
    }

}
